export const INIT_TUNNEL = "INIT_TUNNEL";
export const SET_MODEL = "SET_MODEL";
export const SET_KIT = "SET_KIT";
export const SET_FINISH = "SET_FINISH";
export const SET_EQUIPMENT = "SET_EQUIPMENT";
export const SET_OPTIONS = "SET_OPTIONS";
export const SET_OPTIONS_FOR_CONFIG = "SET_OPTIONS_FOR_CONFIG";
export const ADD_NEW_CONFIGURATION = "ADD_NEW_CONFIGURATION";
export const DELETE_CONFIGURATION = "DELETE_CONFIGURATION";
export const CHANGE_CURRENT_CONFIGURATION = "CHANGE_CURRENT_CONFIGURATION";
export const PERSIST_CONFIGURATIONS = "PERSIST_CONFIGURATION";
export const INCREMENT_MODEL = "INCREMENT_MODEL";
export const DECREMENT_MODEL = "DECREMENT_MODEL";
export const SET_NEGATIVE_DEFAULT_OPTIONS_MODELS = "SET_NEGATIVE_DEFAULT_OPTIONS_MODELS";
export const SET_NEGATIVE_DEFAULT_OPTIONS_FINISH_EQUIPMENT = "SET_NEGATIVE_DEFAULT_OPTIONS_FINISH_EQUIPMENT";
export const CLOSE_ERROR_MODAL = "CLOSE_ERROR_MODAL";
export const CLOSE_MISSING_WINDOW_COLOR_MODAL = "CLOSE_MISSING_WINDOW_COLOR_MODAL";
